import React, { Component } from 'react'
import { Div, Image } from "atomize";
import CustomContainer from '../common/CustomContainer';
import WebsiteContainer from '../common/WebsiteContainer';
import ImageLink from '../common/ImageLink';
import { IsValidUrl } from '../../utilities/helpers';

export default class InfluencerAttention extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
        <Div textAlign="center" maxW="48.75rem" m="auto" bg="#171717">
          <ImageLink link={content.imgLink}><Image src={content.img} h="18.5rem" w="18.5rem" m={{y: {xs: "-4.25rem", md: "-1.4rem"}}} /></ImageLink>
        </Div>
        </CustomContainer>
      </WebsiteContainer>
    )
  }
}
